import * as Period from '../../../../constants/Period';
var BASKETBALL_NCAA_PERIOD_MAP = {};
BASKETBALL_NCAA_PERIOD_MAP[4100] = Period.NOT_STARTED;
BASKETBALL_NCAA_PERIOD_MAP[4101] = Period.FIRST;
BASKETBALL_NCAA_PERIOD_MAP[4102] = Period.FIRST_BREAK;
BASKETBALL_NCAA_PERIOD_MAP[4103] = Period.SECOND;
BASKETBALL_NCAA_PERIOD_MAP[4104] = Period.SECOND_BREAK;
BASKETBALL_NCAA_PERIOD_MAP[4105] = Period.OVERTIME;
BASKETBALL_NCAA_PERIOD_MAP[4106] = Period.FINISHED;
export default BASKETBALL_NCAA_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/BasketballNCAA/PeriodMap.js